import {
    isOpenEndedRange,
    resolveOpenEndedSliderState,
    UNSET_RANGE_BOUND,
} from "../uncappedRangeSliderState";

/** The longest duration any call duration slider offers, in minutes. */
export const MAX_CALL_DURATION = 200;

/** The shortest, and the value either bound takes when it is not set. */
export const MIN_CALL_DURATION = UNSET_RANGE_BOUND;

/**
 * Whether a range runs as far as the duration filter can express, and so reads as "20+ min" rather
 * than as a pair of numbers.
 *
 * The duration-flavoured defaults over `isOpenEndedRange`, which is where the rule and the two
 * stored shapes that mean it are explained. Message Count reads its own range the same way.
 */
export const isOpenEndedCallDuration = (
    min: number | undefined,
    max: number | undefined,
): boolean => isOpenEndedRange(min, max, MAX_CALL_DURATION);

/**
 * How a call duration range should be drawn on a slider. The duration-flavoured defaults over
 * `resolveOpenEndedSliderState`, which is where the thumb-position rule lives.
 */
export const resolveCallDurationSliderState = (
    callDuration: number[] | undefined,
    options?: { maxBound?: number; unitLabel?: string },
): { value: number[]; underSlideLabel?: string } =>
    resolveOpenEndedSliderState(callDuration, {
        ceiling: MAX_CALL_DURATION,
        maxBound: options?.maxBound,
        unitLabel: options?.unitLabel ?? "minutes",
    });
